import {
  VisitType,
  PatientRelationship,
  AppointmentInfo
} from '@kyruus/provider-components';

export enum VisitMethodGroup {
  InPerson = 'in_person',
  Virtual = 'virtual'
}

export interface PurposeOption {
  name: string;
  visit_method: VisitType;
}

export interface BaseAppointmentInfo extends AppointmentInfo {
  relationship: PatientRelationship;
  purpose?: string;
}

export interface FullAppointmentInfo extends BaseAppointmentInfo {
  relationship: PatientRelationship;
  purpose: string;
}

export type PurposeOptionsByRelationship = {
  [key in PatientRelationship]: PurposeOption[];
};

export interface ValidationIssue {
  message: string;
  name: string;
}

export enum BookingStrategies {
  Availability = 'Availability',
  OpenSchedulingWidget = 'OpenSchedulingWidget',
  Button = 'Button'
}

export enum ElectronicHealthRecords {
  MyChart = 'mychart'
}
